import { FIELD_NAMES } from 'const/forms'
import React from 'react'
import { Actions, StyledButton } from '../Shops.styles'
import { formatDate } from 'helpers/dates'
import { PARTNER_OFFER_STATUS_FILTERS } from 'const/shops'
import { EXCLUSIVE_STATUS_FILTERS } from 'const/coupons'
import { formatFieldValue } from 'helpers/formatters/fields'
import Status from 'components/Status'
import { Tag, Tooltip } from 'antd'

const STATUS_COLOR_MAP = {
  not_opened: 'default',
  active: 'green',
  closed: 'red',
  expired: 'volcano',
}

export default (filters, sorter, handleEditAd, handleDeleteAd, handleEditShopOffer) => [
  {
    title: 'ID',
    dataIndex: FIELD_NAMES.id,
    key: FIELD_NAMES.id,
    width: 80,
    fixed: 'left',
    align: 'center',
  },
  {
    title: 'Image',
    dataIndex: ['attributes', 'image_url'],
    key: 'image_url',
    width: 80,
    align: 'center',
    render: (imageUrl) =>
      imageUrl ? (
        <img
          src={imageUrl}
          alt="conquest ad"
          style={{ maxWidth: 60, maxHeight: 40, borderRadius: 4 }}
        />
      ) : (
        '-'
      ),
  },
  {
    title: 'Title',
    dataIndex: ['attributes', FIELD_NAMES.title],
    key: FIELD_NAMES.title,
    width: 200,
    ellipsis: true,
    render: (title) => (
      <Tooltip title={title}>{formatFieldValue(title)}</Tooltip>
    ),
  },
  {
    title: 'Description',
    dataIndex: ['attributes', FIELD_NAMES.description],
    key: FIELD_NAMES.description,
    width: 220,
    ellipsis: true,
    render: (description) => (
      <Tooltip title={description}>{formatFieldValue(description)}</Tooltip>
    ),
  },
  {
    title: 'Allowed Domains',
    dataIndex: ['attributes', FIELD_NAMES.allowedDomains],
    key: FIELD_NAMES.allowedDomains,
    width: 220,
    render: (domains) =>
      Array.isArray(domains) && domains.length ? (
        <>
          {domains.map((domain) => (
            <Tag key={domain}>{domain}</Tag>
          ))}
        </>
      ) : (
        '-'
      ),
  },
  {
    title: 'Shop Offer Code',
    dataIndex: ['attributes', 'shop_offer_code'],
    key: 'shop_offer_code',
    width: 140,
    ellipsis: true,
    render: formatFieldValue,
  },
  {
    title: 'Status',
    dataIndex: ['attributes', FIELD_NAMES.status],
    key: FIELD_NAMES.status,
    width: 120,
    align: 'center',
    filters: PARTNER_OFFER_STATUS_FILTERS,
    filteredValue: filters[FIELD_NAMES.status] || null,
    render: (status) => (
      <Tag color={STATUS_COLOR_MAP[status] || 'default'}>
        {status?.replace('_', ' ')?.toUpperCase() || '-'}
      </Tag>
    ),
  },
  {
    title: 'Exclusive',
    dataIndex: ['attributes', FIELD_NAMES.exclusive],
    key: FIELD_NAMES.exclusive,
    width: 100,
    align: 'center',
    filters: EXCLUSIVE_STATUS_FILTERS,
    filteredValue: filters[FIELD_NAMES.exclusive] || null,
    render: (value) => <Status value={value} />,
  },
  {
    title: 'Priority',
    dataIndex: ['attributes', FIELD_NAMES.priority],
    key: FIELD_NAMES.priority,
    width: 90,
    align: 'center',
    render: formatFieldValue,
  },
  {
    title: 'Started At',
    dataIndex: ['attributes', 'started_at'],
    key: 'started_at',
    width: 120,
    align: 'center',
    render: formatDate,
  },
  {
    title: 'Expired At',
    dataIndex: ['attributes', 'expired_at'],
    key: 'expired_at',
    width: 120,
    align: 'center',
    render: formatDate,
  },
  {
    title: 'Created At',
    dataIndex: ['attributes', 'created_at'],
    key: 'created_at',
    width: 120,
    sorter: true,
    align: 'center',
    sortOrder: sorter.columnKey === 'created_at' && sorter.order,
    render: formatDate,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    align: 'center',
    fixed: 'right',
    width: 180,
    render: (_, ad) => {
      const onEdit = () => handleEditAd(ad[FIELD_NAMES.id])
      const onDelete = () => handleDeleteAd(ad)
      const onEditShopOffer = () => handleEditShopOffer(ad)
      return (
        <Actions>
          <StyledButton onClick={onEdit}>Edit</StyledButton>
          {ad.attributes?.shop_offer_id && (
            <StyledButton onClick={onEditShopOffer}>Edit Shop Offer</StyledButton>
          )}
          <StyledButton onClick={onDelete} type="danger">
            Delete
          </StyledButton>
        </Actions>
      )
    },
  },
]
